import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { triggerBurst } from './Three/ClickBurst';

function NavBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const burst = useCallback((e, color) => {
    const r = e.currentTarget.getBoundingClientRect();
    const resolved = getComputedStyle(document.documentElement).getPropertyValue(color.replace('var(', '').replace(')', '').trim()).trim() || '#0091ff';
    triggerBurst(r.left + r.width / 2, r.top + r.height / 2, resolved);
  }, []);

  return (
    <nav className={`pf-nav${scrolled ? ' scrolled' : ''}`}>
      <a href="/#hero" className="pf-nav-logo">
        JB<span>.</span>
      </a>
      <ul className="pf-nav-links">
        <li><a href="/#about">About</a></li>
        <li><a href="/#projects">Work</a></li>
        <li><a href="/#experience">Experience</a></li>
        <li><a href="/#education">Education</a></li>
        <li className="pf-nav-divider" />
        <li className="pf-nav-actions">
          <Link
            to="/resume"
            className="pf-nav-btn pf-nav-btn-ghost"
            style={{ textDecoration: 'none' }}
            onClick={e => burst(e, 'var(--accent3)')}
          >
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M3 1.5h5L10.5 4v7.5H3V1.5zM7.5 1.5V4h2.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Resume
          </Link>
          <a
            href="/#contact"
            className="pf-nav-btn pf-nav-btn-primary"
            onClick={e => burst(e, 'var(--accent)')}
          >
            <span className="pf-nav-btn-shine" />
            <span className="pf-nav-btn-label">Let's talk</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M2 6h8M7 3l3 3-3 3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </li>
        <li>
          <button
            className="pf-nav-cmd"
            onClick={() => window.dispatchEvent(new KeyboardEvent('keydown', { key: 'k', metaKey: true }))}
            aria-label="Open command palette"
            title="Command palette (⌘K)"
          >
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M2 2.5L5 6.5L2 10.5M6.5 10.5h4.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <kbd>⌘K</kbd>
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default NavBar;
